export function formatPercentage(value) {
  return Number.isInteger(value) ? value : value.toFixed(2);
}

export const calculateSurveyCompletion = (totalUser, totalParticipant) => {
  const completionPercentage = (totalParticipant / totalUser) * 100;
  return isNaN(completionPercentage)
    ? 0
    : formatPercentage(completionPercentage);
};

// Function to create an array of components
export function createArray(number) {
  return Array.from({ length: number }, (_, index) => index);
}